import getById from '../getById'
import toggleClass from '../toggleClass'

interface MultiselectOption {
  [key: string]: string
}
interface MultiselectOptions {
  options: MultiselectOption
  parentId: string
  values: string[]
  availableOptions?: string[]
  cssClass: string
  name?: string
}

function setMultiselectOptions({
  options,
  parentId,
  values = [],
  availableOptions,
  cssClass = '',
  name = `${parentId}--name`
}: MultiselectOptions) {
  const optionsNode = getById(`${parentId}--options`)
  const labelNode = getById(`${parentId}--label`)
  const selectedNode = getById(`${parentId}--selected`)
  const keys = Object.keys(options)

  let setUnavailableText = false
  optionsNode.innerHTML = keys
    .map((key, index) => {
      const value = String(key)
      const checked = values.includes(value)
      const unavailableOption = availableOptions
        ? !availableOptions.includes(value)
        : false

      if (index === 0 || checked) {
        labelNode.textContent = options[key]
      }
      if (unavailableOption) {
        setUnavailableText = true
      }
      return `<div class="multiselect__option py-2 px-4 ${index === 0 ? 'pt-3' : ''} ${
        index === keys.length - 1 && !setUnavailableText ? 'pb-3' : ''
      }">
        <input id="option-${name}-${index}" name="${name}" data-placement="Filters" data-sp-value="${value}"  class="multiselect__option-input ${cssClass}" type="checkbox" value="${value}"${
        checked ? ' checked' : ''
      }></input>
        <label class="multiselect__option-label  mb-0" for="option-${name}-${index}">
          <span class="multiselect__option-title">${options[key]}${
        unavailableOption ? '*' : ''
      }</span>
          <span class="multiselect__option-check"></span>
        </label>
       </div>`
    })
    .join('')

  if (setUnavailableText) {
    const helpTextNode = document.createElement('div')
    helpTextNode.className = 'multiselect__option--bordered mx-4 pt-1 pb-3 meta'
    helpTextNode.textContent = '* Changes could alter other plan options.'
    optionsNode.appendChild(helpTextNode)
  }

  const validOptions = Object.keys(options).filter(key => !!options[key])
  if (selectedNode && validOptions.length <= 1) {
    delete selectedNode.dataset.toggle
    toggleClass(selectedNode, 'multiselect-disabled', true)
  }
}

export default setMultiselectOptions
